<template>
  <div class="login-dialog">
    <div class="title">欢迎登录</div>
    <div class="content">
      <div class="telephone">
        <span>手机号</span>
        <el-input
          v-model="telephone"
          placeholder="请输入手机号"
          maxlength="11"
          size="medium"
        ></el-input>
      </div>
      <div class="password">
        <span>密码</span>
        <el-input
          v-model="password"
          show-password
          placeholder="请输入密码"
          size="medium"
        ></el-input>
      </div>
      <div class="login-tips">
        登录即代表同意<el-link
          href="/#/userProtocol"
          class="privacy-link"
          target="_blank"
          type="primary"
          >《用户协议》</el-link
        >及<el-link
          href="/#/privacy"
          class="privacy-link"
          target="_blank"
          type="primary"
          >《隐私政策》</el-link
        >
      </div>
      <div
        class="login-btn"
        :click="{ 'disabled-btn': submitting }"
        @click="login"
        v-loading="submitting"
      >
        登录
      </div>
      <div class="more-link">
        <div class="forget-password" @click="showForgetPage">忘记密码</div>
        <div class="reg" @click="showRegPage">注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      telephone: "",
      password: "",
      submitting: false
    };
  },
  methods: {
    async login() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      if (this.telephone.length !== 11 || this.password.length === 0) {
        this.submitting = false;
        this.$message.error("请输入正确的手机号或密码！");
        return;
      } else {
        this.submitting = true;
        const params = {
          phone: this.telephone,
          password: this.password,
          lastLoginTerminal: 0
        };
        let res = await httpRequest("/app/user/token", "get", params);
        if (res !== null && res !== undefined && res.code === 200) {
          this.$message.success("登录成功");
          localStorage.setItem("pc_user_token", res.data);
          // 继续获取用户信息
          res = await httpRequest("/app/user", "get", null);
          if (res !== null && res !== undefined && res.code === 200) {
            localStorage.setItem("pc_user", JSON.stringify(res.data));
          }
          // 跳转到首页
          this.$router.push({ path: "/" });
        }
        this.submitting = false;
      }
    },
    showForgetPage() {
      this.$router.push({ path: "/forget" });
    },
    showRegPage() {
      this.$router.push({ path: "/reg" });
    }
  }
};
</script>

<style scoped lang="scss">
.login-dialog {
  width: 850px;
  height: 544px;
  background: #ffffff;
  margin-top: 150px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 4px;
  color: rgba(51, 51, 51, 1);
  .title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    background: rgba(0, 176, 171, 1);
  }
  .content {
    margin-left: 145px;
    margin-right: 145px;
    margin-top: 89px;
    .telephone {
      font-size: 18px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      span {
        display: inline-block;
        width: 54px;
      }
      .el-input {
        width: 361px;
        margin-left: 46px;
      }
    }
    .password {
      margin-top: 35px;
      font-size: 18px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      span {
        display: inline-block;
        width: 54px;
        text-align: right;
      }
      .el-input {
        width: 361px;
        margin-left: 46px;
      }
    }
    .login-tips {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-left: 150px;
      text-align: left;
    }
    .login-btn {
      height: 50px;
      line-height: 50px;
      background: rgba(0, 176, 171, 1);
      border-radius: 4px;
      margin-top: 60px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
    .disabled-btn {
      cursor: auto !important;
    }
    .more-link {
      text-align: right;
      margin-top: 15px;
      div {
        display: inline-block;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(110, 110, 110, 1);
        line-height: 22px;
        cursor: pointer;
      }
      .forget-password {
        padding-left: 20px;
        padding-right: 20px;
        border-right: 1px solid #979797;
      }
      .reg {
        padding-left: 20px;
      }
    }
  }
}
</style>
